const sourceKeysCompeso = {
    description: 'description',
    genres: 'genres',
    title: 'title',
    trailerURL: 'trailer_url'
}

const sourceKeysKinoheld = {
    description: 'description',
    genres: 'genres',
    title: 'title',
    trailerURL: 'trailerUrls'
}

const sourceKeysMars = {
    description: 'description',
    genres: 'genres',
    title: 'title',
    trailerURL: 'trailer_url'
}

const movieAttrToSourceAttr = (movieKey, provider) => {
    if(provider === "Mars") {
        return sourceKeysMars.hasOwnProperty(movieKey) ? sourceKeysMars[movieKey] : false
    } else if(provider === "Kinoheld") {
        if(movieKey === "trailerURL") {
            return sourceKeysKinoheld.hasOwnProperty(movieKey) ? sourceKeysKinoheld[movieKey] : false
        }
        return sourceKeysKinoheld.hasOwnProperty(movieKey) ? sourceKeysKinoheld[movieKey] : false
    } else {
       return sourceKeysCompeso.hasOwnProperty(movieKey) ? sourceKeysCompeso[movieKey] : false
    }
}

export default movieAttrToSourceAttr